import { PopOverMenu } from "components/popups/PopOverMenu";
import { IGroup } from "components/popups/PopOverMenu/PopOverMenu";

interface IMoreMenuProps {
  isOpen: boolean;
  anchorEl: Element | null;
  onClose: () => void;
  menuItems: IGroup[];
}

export const MoreMenu: React.FC<IMoreMenuProps> = (props) => {
  return (
    <PopOverMenu
      className="MoreMenu"
      title="Options"
      {...props}
    />
  );
};
